import { Select } from 'antd';
import { observer } from 'mobx-react-lite';
import * as React from 'react';
import './TestProjectTagsFilter.less';

const { Option } = Select;

type TagWithCount = {
    tag: string;
    count: number;
};

type Props = {
    availableTagsWithCounts: TagWithCount[];
    selectedTags: string[];
    onChange: (tags: string[]) => void;
};

export const NO_TAGS_VALUE = '__NO_TAGS__';

const TestProjectTagsFilter: React.FC<Props> = ({ availableTagsWithCounts, selectedTags, onChange }) => {
    return (
        <Select
            data-id="test-projects-tags-filter"
            className="test-projects-tags-filter"
            mode="multiple"
            value={selectedTags}
            onChange={onChange}
            placeholder="Filter by tags..."
            allowClear
            showSearch
            optionLabelProp="label"
            filterOption={(input, option) =>
                option?.children?.toString().toLowerCase().includes(input.toLowerCase()) ?? false
            }
        >
            <Option key={NO_TAGS_VALUE} value={NO_TAGS_VALUE} label="NO TAGS">
                <div className="test-projects-tags-option">
                    <span className="no-tags-text">NO TAGS</span>
                </div>
            </Option>
            {availableTagsWithCounts.map(({ tag, count }) => (
                <Option key={tag} value={tag} label={tag} title={tag}>
                    <div className="test-projects-tags-option">
                        <span className="tag-text">{tag}</span>
                        <span className="tag-count">{count}</span>
                    </div>
                </Option>
            ))}
        </Select>
    );
};

export default observer(TestProjectTagsFilter);
